// extracted by mini-css-extract-plugin
export default {"wrapper":"upload-box_wrapper__4JpA0"};